import { showError } from "utils/notifications";

// Reusable room enrichment function
export const enrichRoom = (room, typeDetails, values) => {
    if (!typeDetails) return room;
    return {
        ...room,
        extra_bed_charge: typeDetails.extra_bed_charge ?? room.extra_bed_charge ?? 0,
        extra_person_charge: typeDetails.extra_person_charge ?? room.extra_person_charge ?? 0,
        extra_child_charge: typeDetails.extra_child_charge ?? room.extra_child_charge ?? 0,
        capacity: typeDetails.capacity ?? room.capacity ?? 0,
        extra_Capablity: typeDetails.exbed_capability ?? room.exbed_capability,
        exbed_capability_limit: typeDetails?.exbed_capability_limit ?? room.exbed_capability_limit ?? 0,
    };
};

// Disable specific fields in a field array
export const disableFields = (fields, fieldNames) => {
    return fields?.map(field => {
        if (fieldNames.includes(field.name)) {
            return { ...field, disabled: true };
        }
        return field;
    });
};

export const percentOf = (percent, amount) =>
    (Number(percent || 0) * Number(amount || 0)) / 100;

export const normalizeCustomerOption = (option) => {
    if (!option) return null;

    const fd = option.fullData || {};
    const customer_id = fd.customer_id;
    const full_guest_name = fd.full_guest_name;
    const country_dial_code = fd.country_dial_code;
    const mobile = fd.mobile;

    return customer_id ? { customer_id, full_guest_name, country_dial_code, mobile } : null;
};

export const RoomFieldsOpction = (
    field,
    room,
    roomTypesOption,
    roomNumbersByType,
    selectedRoomIds,
) => {

    if (field === "room_type_id") {
        return roomTypesOption.map(({ room_type_id, room_type }) => ({
            value: room_type_id,
            label: room_type
        }));
    }

    // if (field === "room_id") {

    //     let rooms = [...(roomNumbersByType?.[room?.room_type_id] || [])];

    //     const exists = rooms.some(
    //         (r) => r.room_id === room.room_id
    //     );

    //     if (!exists && room?.room_id) {
    //         rooms.push({
    //             room_id: room.room_id,
    //             room_no: room.room_no,
    //             avalible_beds: room.avalible_beds || 0
    //         });
    //     }

    //     const selectedRoom = rooms.find(
    //         (r) => r.room_id === room.room_id
    //     );


    //     room.avalible_beds = selectedRoom?.avalible_beds || 0;

    //     return rooms
    //         .filter(
    //             (r) =>
    //                 !selectedRoomIds.map(String).includes(String(r.room_id)) ||
    //                 r.room_id === room.room_id
    //         )
    //         .map(({ room_id, room_no, avalible_beds }) => ({
    //             value: room_id,
    //             label: `${room_no}${room.accommodation_type === "DORMITORY"
    //                 ? ` - Available Beds: ${avalible_beds || 0}`
    //                 : ""
    //                 }`
    //         }));
    // }

    if (field === "room_id") {
        let rooms = [...(roomNumbersByType?.[room?.room_type_id] || [])].map(
            (r) => ({
                ...r,
                room_id: String(r.room_id)
            })
        );

        const currentRoomId = String(room?.room_id ?? "");

        const exists = rooms.some(
            (r) => r.room_id === currentRoomId
        );

        if (!exists && room?.room_id) {
            rooms.push({
                room_id: currentRoomId,
                room_no: room.room_no,
                avalible_beds: room.avalible_beds || 0
            });
        }

        const selectedRoom = rooms.find(
            (r) => r.room_id === currentRoomId
        );

        room.avalible_beds = selectedRoom?.avalible_beds || 0;

        return rooms
            .filter(
                (r) =>
                    !selectedRoomIds.map(String).includes(r.room_id) ||
                    r.room_id === currentRoomId
            )
            .map(({ room_id, room_no, avalible_beds }) => ({
                value: room_id,
                label: `${room_no}${room.accommodation_type === "DORMITORY"
                    ? ` - Available Beds: ${avalible_beds || 0}`
                    : ""
                    }`
            }));
    }
};

export const handleConfirm = (
    selectedCustomerId,
    selectedCustomer,
    customerType,
    setExistingCustomers,
    setValues,
    newCustomer,
    setShow,
    setSelectedCustomer
) => {
    if (customerType === "existing") {
        if (!selectedCustomerId) return showError("Please select a customer");

        setExistingCustomers((prev) => {
            const exists = prev.some((c) => String(c.customer_id) === String(selectedCustomerId));
            if (exists) return prev;
            return selectedCustomer?.customer_id ? [...prev, selectedCustomer] : prev;
        });

        setValues((prev) => ({ ...prev, customer_id: selectedCustomerId }));
    }

    if (customerType === "new") {
        if (!newCustomer.name || !newCustomer.phone) {
            alert("Please enter all fields");
            return;
        }
    }
    setShow(false);
};

// helpers/customerHelpers.js
export const deleteCustomerHelper = ({
    customerId,
    setExistingCustomers,
    setValues,
    selectedCustomerId,
    setSelectedCustomerId
}) => {

    const id = String(customerId);

    setExistingCustomers(prev =>
        prev.filter(c => String(c.customer_id) !== id)
    );

    setValues(prev => ({
        ...prev,
        customer_id: String(prev.customer_id) === id ? "" : prev.customer_id
    }));

    if (String(selectedCustomerId) === id) {
        setSelectedCustomerId("");
    }
};

export const deleteGuestHelper = ({
    guestId,
    setExistingGuests,
    setValues,
}) => {

    const id = String(guestId);

    setExistingGuests(prev =>
        prev.filter(g => String(g.guest_id) !== id)
    );

    setValues(prev => ({
        ...prev,
        guest_id: String(prev.guest_id) === id ? "" : prev.guest_id
    }));

};


export const getAllowedFieldsByType = (form_data) => {
    const allRoomFields = [
        ...form_data.RoomFields,
        ...form_data.extraFields,
        ...form_data.Rent_Info,
    ];

    return {
        ROOM: allRoomFields
            .filter(f => !f.showFor || f.showFor.includes("ROOM"))
            .map(f => f.name),

        DORMITORY: allRoomFields
            .filter(f => !f.showFor || f.showFor.includes("DORMITORY"))
            .map(f => f.name),
    };
}

export const validateAdvanceRow = (
    row,
    paymentMethodTypesOption = []
) => {
    const paymentMethod = paymentMethodTypesOption.find(
        (item) =>
            Number(item.payment_method_id) === Number(row?.payment_method)
    );

    const paymentMethodName = (
        paymentMethod?.payment_method_name || ""
    )
        .trim()
        .toLowerCase();

    // Payment methods that do NOT require Transaction ID
    const transactionOptionalMethods = ["cash"];

    const isTransactionOptional = transactionOptionalMethods.includes(
        paymentMethodName
    );

    const hasPaymentMethod = !!row?.payment_method;
    const hasTransactionId = !!String(
        row?.transaction_id ?? ""
    ).trim();
    const hasAdvanceAmount = !!String(
        row?.advance_amount ?? ""
    ).trim();

    const anyFilled =
        hasPaymentMethod ||
        hasTransactionId ||
        hasAdvanceAmount;

    // Nothing entered
    if (!anyFilled) return {};

    const errors = {};

    if (!hasPaymentMethod) {
        errors.payment_method = "Payment Method is required";
    }

    if (!isTransactionOptional && !hasTransactionId) {
        errors.transaction_id = "Transaction ID is required";
    }

    if (!hasAdvanceAmount) {
        errors.advance_amount = "Advance Amount is required";
    }

    return errors;
};


export const fetchOptions = {}
